<template>
  <div>
    <div>
      <b-card-group>
        <b-card no-body>
          <b-collapse visible id="filterCollapse">
            <div class="card-body certificate-form"> 
              <div>
                <b-form>
                  <b-row>
                    <b-col cols="1">
                      <b-button v-on:click="resetFilter" size="sm" variant="secondary" class="ml-2">
                        <font-awesome-icon icon="times" />
                        {{ $t('Сброс') }}
                      </b-button>
                    </b-col>
                    <template>
                      <filter-input
                      :label="$t('№ акта из лаб.')"
                      v-on:onBlur="search"
                      placeholder="с"
                      :cols="1"
                      v-model="form.certificateNumberFrom"
                      class="small-padding"
                      ></filter-input>
                      <filter-input
                        label="&nbsp;"
                        placeholder="по"
                        v-on:onBlur="search"
                        :cols="1"
                        v-model="form.certificateNumberTo"
                        class="small-padding"
                      ></filter-input>
                      <filter-date-between
                      :label="$t('Дата поступления в орг.')"
                      v-on:onChange="search"
                      :cols="2"
                      v-model="receiptinDateRange"
                      class="small-padding"
                    ></filter-date-between>
                      <filter-date-between
                      :label="$t('Дата поступления в лаб.')"
                      v-on:onChange="search"
                      :cols="2"
                      v-model="receiptinLabDateRange"
                      class="small-padding"
                    ></filter-date-between>
                    <filter-select
                      :label="$t('Образец')"
                      :withoutEmpty="true"
                      v-model="form.biomaterialSampleIds"
                      :empty-as-null="true"
                      :cols="2"
                      :multiple="true"
                      v-on:input="search"
                      v-on:onChange="search"
                      :options="biomaterialSamples"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Приоритетные')"
                      v-model="form.isPriority"
                      :empty-as-null="true"
                      :cols="2"
                      v-on:onChange="search"
                      :options="yesNo"
                      class="small-padding"
                    ></filter-select>
                    </template>
                  </b-row>
                  <b-row>
                    <b-col :cols="6" :sm="4" :md="2" :lg="2" :xl="1"></b-col>
                    <filter-select
                      :label="$t('Данные о поступлении')"
                      v-model="form.entryType"
                      :empty-as-null="true"
                      :cols="2"
                      v-on:input="search"
                      v-on:onChange="search"
                      :options="entryTypes"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Акция')"
                      v-model="form.entryActionId"
                      :empty-as-null="true"
                      :cols="2"
                      v-on:input="search"
                      v-on:onChange="search"
                      :options="entryActions"
                      class="small-padding"
                    ></filter-select>
                    <filter-select
                      :label="$t('Мед. учреждение')"
                      v-model="form.entryMedicalOfficeId"
                      :empty-as-null="true"
                      :cols="2"
                      v-on:input="search"
                      v-on:onChange="search"
                      :options="entryMedicalOffices"
                      class="small-padding"
                    ></filter-select>
                    <filter-input
                      :label="$t('Город (акция / клиники, СПК)')"
                      v-on:onBlur="search"
                      :cols="2"
                      v-model="form.incomeCity"
                      class="small-padding"
                    ></filter-input>
                  </b-row>
                </b-form>
              </div>
            </div>
          </b-collapse>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';
import { EventBus } from '@/event-bus';

export default {
  extends: BaseFilter,
  name: 'filter-form',
  props: [
    'id',
    'certificateNumberFrom',
    'certificateNumberTo',
    'receiptInFrom',
    'receiptInTo',
    'receiptInLaboratoryFrom',
    'receiptInLaboratoryTo',
    'biomaterialSampleIds',
    'incomeCity',
    'entryMedicalOfficeId',
    'entryType',
    'entryActionId',
    'isPriority',
  ],
  data() {
    return {
      form: {
        id: this.id || null,
        biomaterialSampleIds: this.biomaterialSampleIds || [],
        receiptInFrom: this.receiptInFrom || null,
        receiptInTo: this.receiptInTo || null,
        certificateNumberFrom: this.certificateNumberFrom || null,
        certificateNumberTo: this.certificateNumberTo || null,
        entryType: this.entryType || null,
        incomeCity: this.incomeCity || null,
        entryMedicalOfficeId: this.entryMedicalOfficeId || null,
        entryActionId: this.entryActionId || null,
        isPriority: this.isPriority || null,
      },
      receiptinDateRange: [],
      receiptinLabDateRange: [],
      biomaterialSamples: [],
      entryTypes: [],
      entryActions: [],
      entryMedicalOffices: [],
      yesNo: [],
    };
  },
  mounted() {
    const receiptInFrom = this.receiptInFrom ? new Date(this.receiptInFrom) : this.receiptInFrom;
    const receiptInTo = this.receiptInTo ? new Date(this.receiptInTo) : this.receiptInTo;
    this.receiptinDateRange = [receiptInFrom, receiptInTo];
    const receiptInLabFrom = this.receiptInLaboratoryFrom ? new Date(this.receiptInLaboratoryFrom) : this.receiptInLaboratoryFrom;
    const receiptInLabTo = this.receiptInLaboratoryTo ? new Date(this.receiptInLaboratoryTo) : this.receiptInLaboratoryTo;
    this.receiptinLabDateRange = [receiptInLabFrom, receiptInLabTo];
    
    this.mapMultiselectValues(['biomaterialSample']);
    this.applyDateRangeWatcher();
    let self = this;
    EventBus.$on('gridDataLoaded', function(data) {
      self.regions = data.regions;
    });
  },
  methods: {
    mapMultiselectValues(keys) {
      for(let i = 0; i < keys.length; i++) {
        let key = keys[i];
        let data = this.form[key + 'Ids'];
        if(data) {
          this.form[key + 'Ids'] = Array.isArray(data) ? data.map(Number) : [parseInt(data)];
        }
      }
    },
    applyDateRangeWatcher() {
      this.$watch('receiptinDateRange', function() {
        this.form.receiptInFrom = this.receiptinDateRange[0] ? this.receiptinDateRange[0].toJSON() : '';
        this.form.receiptInTo = this.receiptinDateRange[1] ? this.receiptinDateRange[1].toJSON() : '';
        this.search();
      });
      this.$watch('receiptinLabDateRange', function() {
        this.form.receiptInLaboratoryFrom = this.receiptinLabDateRange[0] ? this.receiptinLabDateRange[0].toJSON() : '';
        this.form.receiptInLaboratoryTo = this.receiptinLabDateRange[1] ? this.receiptinLabDateRange[1].toJSON() : '';
        this.search();
      });
    },
    getDictionaries() {
      axios.get('/Dictionary/GetLrOrganizationCodes')
           .then((response) => {
            this.lrOrganizations = response.data;
          });
      axios.get('/pmdd/DictionaryGroup')
        .then((response) => {
          this.biomaterialSamples = response.data.biomaterial_samples;
          this.entryTypes = response.data.entry_types;
          this.entryActions = response.data.entry_actions;
          this.entryMedicalOffices = response.data.entry_medical_offices;
          this.yesNo = response.data.yes_no;
        });
    },
    search: function() {
      this.$emit('search', this.form);
    },
    resetFilter(e) {
      this.reset(e, () => {
        this.receiptinDateRange = [];
        this.receiptinLabDateRange = [];
        this.form.nationalities = [];
        this.form.biomaterialSampleIds = [];
      });
    },
  },
};
</script>
